import { Button, Checkbox, DatePicker, Form, Input } from "antd";
import { Copy } from "lucide-react";
import type { FormValues, BookingPreview } from "./types";
import { FormProps } from "antd";

interface CopyOptionsFormProps {
  selectedBooking: BookingPreview | undefined;
  onSubmit: FormProps<FormValues>["onFinish"];
  isSubmitting: boolean;
}

export const CopyOptionsForm = ({
  selectedBooking,
  onSubmit,
  isSubmitting,
}: CopyOptionsFormProps) => {
  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <div className="bg-white rounded-lg border p-6 mb-6 shadow-sm">
        <h2 className="text-xl font-medium mb-6">Copy Options</h2>
        <Form.Item
          name="copyClient"
          valuePropName="checked"
          className="mb-0"
          initialValue={true}
        >
          <Checkbox>Copy Client Information</Checkbox>
        </Form.Item>
        <Form.Item
          name="copyInventory"
          valuePropName="checked"
          className="mb-0"
          initialValue={true}
        >
          <Checkbox>Copy Inventory Items</Checkbox>
        </Form.Item>
        <Form.Item
          name="copyServices"
          valuePropName="checked"
          className="mb-0"
          initialValue={true}
        >
          <Checkbox>Copy Service Types</Checkbox>
        </Form.Item>
        <Form.Item
          name="copyDates"
          valuePropName="checked"
          className="mb-2"
          initialValue={false}
        >
          <Checkbox>Copy Dates (or select new dates below)</Checkbox>
        </Form.Item>
        <Form.Item
          name="newBookingDate"
          label="New Booking Date"
          className="mb-2"
          layout="vertical"
        >
          <DatePicker />
        </Form.Item>
        <Form.Item
          name="newProjectName"
          label="New Project Name (Optional)"
          className="mb-0"
          layout="vertical"
          initialValue={"Summer Exhibition 2025"}
        >
          <Input placeholder="Enter new project name..." />
        </Form.Item>
      </div>
      <div className="flex justify-end space-x-4">
        <button
          type="button"
          className="px-4 py-2 border rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <Button
          htmlType="submit"
          size="large"
          type="primary"
          disabled={!selectedBooking}
          loading={isSubmitting}
          className="px-4 py-2 rounded-lg flex items-center"
        >
          <Copy size={16} className="mr-2" />
          Create Copy
        </Button>
      </div>
    </Form>
  );
};
